{
  "name": "virtual-ng",
  "version": "0.0.10",
  "scripts": {
    "ng": "ng",
    "start": "nx serve",
    "start:dev": "nx serve --configuration development",
    "start:staging": "nx serve --configuration staging",
    "start:prod": "nx serve --configuration production",
    "start:pwa": "nx build --configuration development && npx serve -s dist/virtual-ng/browser -p 4200",
    "build": "nx build",
    "build:dev": "nx build --configuration development",
    "build:staging": "nx build --configuration staging",
    "build:prod": "nx build --configuration production",
    "watch": "nx build --watch --configuration development",
    "format": "prettier --write \"**/*.{js,mjs,ts,mts,d.ts,html}\" --cache",
    "test": "nx test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20",
    "@angular/common": "^20",
    "@angular/compiler": "^20",
    "@angular/core": "^20",
    "@angular/forms": "^20",
    "@angular/platform-browser": "^20",
    "@angular/platform-browser-dynamic": "^20",
    "@angular/router": "^20",
    "@angular/service-worker": "^20.1.3",
    "@primeuix/themes": "^1.2.1",
    "@tailwindcss/postcss": "^4.1.11",
    "chart.js": "4.4.2",
    "face-api.js": "^0.22.2",
    "file-saver": "^2.0.5",
    "primeclt": "^0.1.5",
    "primeicons": "^7.0.0",
    "primeng": "^20",
    "rxjs": "~7.8.2",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.8.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20",
    "@angular-devkit/core": "^20",
    "@angular-devkit/schematics": "^20",
    "@angular/cli": "^20",
    "@angular/compiler-cli": "^20",
    "@nx/angular": "22.6.5",
    "@nx/workspace": "22.6.5",
    "@schematics/angular": "^20",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "autoprefixer": "^10.4.20",
    "eslint": "^9.30.1",
    "eslint-config-prettier": "^10.1.5",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.5.1",
    "jasmine-core": "~5.8.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "nx": "22.6.5",
    "postcss": "^8.5.6",
    "prettier": "^3.6.2",
    "tailwindcss": "^4.1.11",
    "typescript": "~5.8.3"
  }
}
